<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="container row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createClient">
              <h2>Dados do cliente</h2>
              <div class="space-25"></div>
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.fullName"
                />
              </div>
              <div class="form-group">
                <label>Horário para auto takeout (Horas)</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="form.autoTakeoutHour"
                />
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.disable"
                />
                <label class="form-check-label checkboxlabel">Desativado</label>
              </div>
              <br />
              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="!form.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Cliente
              </button>

              <div v-if="form.control.editModeId">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar Cliente
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ClientsList ref="ListRef" @select-client="enterEditMode" />
    </div>
  </div>
</template>
<script>
import ClientsList from './components/clients-list/ClientsList';
export default {
  components: {
    ClientsList,
  },
  data() {
    return {
      form: {
        fullName: '',
        autoTakeoutHour: '',
        disable: false,
        control: {
          editModeId: '',
        },
      },
    };
  },
  methods: {
    async createClient() {
      try {
        const payload = {
          fullName: this.form.fullName,
          autoTakeoutHour: this.form.autoTakeoutHour,
        };
        await this.$store.dispatch('CLIENT/Create', payload);
        await this.$refs.ListRef.listClients();
      } catch (error) {
        this.$toasted.error('Falha ao criar cliente');
      }
    },
    enterEditMode(client) {
      this.form.fullName = client.fullName;
      this.form.autoTakeoutHour = client.autoTakeoutHour;
      this.form.disable = client.disable;
      this.form.control.editModeId = client._id;
    },
    disableEditMode() {
      this.form.fullName = '';
      this.form.autoTakeoutHour = '';
      this.form.disable = '';
      this.form.control.editModeId = '';
    },
    async saveEdition() {
      try {
        const payload = {
          fullName: this.form.fullName,
          autoTakeoutHour: this.form.autoTakeoutHour,
          disable: this.form.disable,
        };
        const clientId = this.form.control.editModeId;
        await this.$store.dispatch('CLIENT/Update', { payload, clientId });
        this.disableEditMode();
        await this.$refs.ListRef.listClients();
      } catch (error) {
        this.$toasted.error('Falha ao atualizar cliente');
      }
    },
  },
};
</script>